module.exports = __webpack_public_path__ + "img/i_from_info.209de522.svg";